import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Formik } from "formik";
import * as Yup from "yup";
import { Form, Button } from "react-bootstrap";
//
import { login } from "../../../state/actions/auth/auth";
import useRedirectAfterAuth from "../../../hooks/useRedirectAfterAuth";

function LoginCard(props) {
    useRedirectAfterAuth();
    const formikRef = useRef();
    const [isLoading, setisLoading] = useState(false);
    const [formSubmitted, setformSubmitted] = useState(false);

    // loading
    useEffect(() => {
        setisLoading(props.isLoading);
    }, [props.isLoading]);

    // submit success
    useEffect(() => {
        if (!props.isLoading && formSubmitted) {
            if (props.loginAttemptFailed) {
                setformSubmitted(false);
            } else {
                formikRef.current.resetForm();
            }
        }
    }, [props.isLoading]);

    //
    function handleFormSubmit(values, { resetForm }) {
        props.login(values.email, values.password);
        setformSubmitted(true);
    }
    //

    const FormSchema = Yup.object().shape({
        email: Yup.string().email("Invalid email").required("Required"),
        password: Yup.string()
            .min(2, "Too Short!")
            .max(50, "Too Long!")
            .required("Required"),
    });

    return (
        <div className="card bg-gradient-white card-tile border border-soft mb-0">
            <div className="card-header bg-transparent pb-lg-5 d-none d-md-block">
                <div className="text-center mt-lg-2 mb-lg-1 font-size-12">
                    Kindly login to proceed
                </div>
            </div>
            <div className="card-body px-lg-5 pb-lg-5 pt-lg-2">
                <Formik
                    validationSchema={FormSchema}
                    onSubmit={handleFormSubmit}
                    initialValues={{
                        email: "",
                        password: "",
                    }}
                    innerRef={formikRef}
                    validateOnChange={false}
                    validateOnBlur={true}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        touched,
                        errors,
                        isSubmitting,
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            {/* Error message */}
                            {Object.keys(errors).length > 0 && (
                                <p className="text-danger">
                                    Please correct the errors below and attempt
                                    resubmitting the form.
                                </p>
                            )}

                            {/* Email  */}
                            <Form.Group controlId="validationLoginFormemail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control
                                    className="form-control"
                                    disabled={isLoading}
                                    type="email"
                                    // placeholder="Email"
                                    name="email"
                                    value={values.email}
                                    onChange={handleChange}
                                    isInvalid={!!errors.email}
                                    isValid={
                                        !props.loginAttemptFailed &&
                                        touched.email &&
                                        !errors.email
                                    }
                                />
                                {/* <Form.Control.Feedback>
                                    Looks good!
                                </Form.Control.Feedback> */}
                                <Form.Control.Feedback type="invalid">
                                    {errors.email}
                                </Form.Control.Feedback>
                            </Form.Group>

                            {/* Password  */}
                            <Form.Group controlId="validationLoginFormpassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    className="form-control"
                                    disabled={isLoading}
                                    type="password"
                                    // placeholder="*******"
                                    name="password"
                                    value={values.password}
                                    onChange={handleChange}
                                    isInvalid={!!errors.password}
                                    isValid={
                                        !props.loginAttemptFailed &&
                                        touched.password &&
                                        !errors.password
                                    }
                                />
                                {/* <Form.Control.Feedback>
                                    Looks good!
                                </Form.Control.Feedback> */}
                                <Form.Control.Feedback type="invalid">
                                    {errors.password}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Button
                                type="submit"
                                className="analytics-login-button-submit btn btn-dark mt-4 mb-3 w-100"
                                disabled={isLoading}
                            >
                                {isLoading ? "Loading..." : "Log In"}
                            </Button>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
}

LoginCard.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    loginAttemptFailed: PropTypes.bool.isRequired,
    login: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    isAuthenticated: state.authReducer.isAuthenticated,
    isLoading: state.authReducer.isLoading,
    loginAttemptFailed: state.authReducer.loginAttemptFailed,
});

const mapDispatchToProps = {
    login,
};
export default connect(mapStateToProps, mapDispatchToProps)(LoginCard);
